



















































import {
  Component, Prop, Vue, PropSync,
} from 'vue-property-decorator';
import {
  UnitsApi, Unit, UserApi, User,
} from '@compassdigital/foodworks.ts.sdk';
import AppModule from '@/store/modules/app';
import UserModule from '@/store/modules/user';
import ToastModule from '@/store/modules/toast';
import UnitsUtil from '@/util/UnitUtil';
import Service from '@/util/ServiceUtil';
import Format from '@/util/Format';

@Component({
  components: {},
})
export default class UnitsList extends Vue {
  @PropSync('markets', {}) marketsSync!: any;

  @PropSync('scouts', {}) scoutsSync!: any;

  @Prop({ default: false }) public marketsLoaded!: boolean;

  @Prop({ default: false }) public scoutsLoaded!: boolean;

  @Prop() public search!: any;

  @Prop() public searchMarket!: any;

  @Prop() public searchScout!: any;

  @PropSync('deleteIcon') deleteIconSync!: any;

  @PropSync('unitListProfiles', {}) unitListProfileSync!: any;

  @PropSync('unitsArray', {}) unitsArraySync!: any;

  @PropSync('unitDeleteCheck', {}) unitDeleteCheckSync!: boolean;

  @Prop() public searchStatus!: any;

  public loading: boolean = false;

  public errors: string = '';

  private unitsItems: any[] = [];

  private scoutItems: User [] = [];

  private headers = [
    {
      text: '',
      align: 'center',
      value: 'checkbox',
      width: '30px',
    },
    {
      text: 'Unit',
      align: 'left',
      value: 'unitName',
      width: '232px',
    },
    {
      text: 'Market',
      align: 'left',
      value: 'marketName',
      width: '152px',
    },
    {
      text: 'FW Employee',
      align: 'left',
      value: 'scoutName',
      width: '176px',
    },
    {
      text: 'Status',
      align: 'left',
      value: 'unitStatus',
      width: '176px',
    },
  ];

  private waitForMarketsAndScouts(): Promise<void> {
    return new Promise((resolve) => {
      const isReady = () => this.marketsLoaded && this.scoutsLoaded;

      if (isReady()) {
        resolve();
        return;
      }

      let done = false;
      let timeoutId: ReturnType<typeof setTimeout>;
      let unwatch: () => void;

      const finish = () => {
        if (done) return;
        done = true;
        clearTimeout(timeoutId);
        unwatch();
        resolve();
      };

      unwatch = this.$watch(
        () => [this.marketsLoaded, this.scoutsLoaded],
        () => {
          if (isReady()) finish();
        },
      );

      timeoutId = setTimeout(finish, 19000);
    });
  }

  public mounted() {
    this.getAllUnits();
    if (this.$route.params.message) {
      ToastModule.setToast({
        message: this.$route.params.message,
        timeout: 2000,
      });
    }
  }

  public async getAllUnits() {
    try {
      this.loading = true;
      await this.waitForMarketsAndScouts();
      if (AppModule.isLoggedIn && AppModule.accessToken) {
        try {
          const api = new UnitsApi(AppModule.apiConfig);
          const units: any = await api.getsUnits();
          this.unitsItems = UnitsUtil.getMappedUnits(
            units.data,
            this.marketsSync,
            this.scoutsSync,
          );
        } catch (err) {
          throw err;
        }
      }
    } catch (err) {
      if (err.error) {
        this.errors = err.error;
      }
    }
    this.loading = false;
  }

  public onClickRow(item: any) {
    if (item) {
      const { id } = item;
      this.$router.push({ name: 'schedule-settings', params: { id } });
    }
  }

  get filteredItems() {
    if (this.unitDeleteCheckSync) {
      this.getAllUnits();
      this.unitDeleteCheckSync = false;
    }
    let filteredUnits = this.unitsItems;
    if (this.search) {
      filteredUnits = filteredUnits.filter(
        unit => (unit.unitName!).toLowerCase()
          .includes(this.search.toLowerCase())
        || (unit.marketName!)
          .toLowerCase()
          .includes(this.search.toLowerCase())
        || (unit.scoutName!)
          .toLowerCase()
          .includes(this.search.toLowerCase())
        || (unit.unitStatus!)
          .toLowerCase()
          .includes(this.search.toLowerCase()),
      );
    }

    if (this.searchMarket && this.searchMarket.length > 0) {
      filteredUnits = filteredUnits.filter(
        unit => this.searchMarket.includes(unit.marketID),
      );
    }
    if (this.searchScout && this.searchScout.length > 0) {
      filteredUnits = filteredUnits.filter(
        unit => this.searchScout.includes(unit.scoutUserID),
      );
    }
    if (this.searchStatus && this.searchStatus.length > 0) {
      filteredUnits = filteredUnits.filter(
        unit => this.searchStatus.includes(unit.unitStatus),
      );
    }
    if (this.unitsArraySync.length === 0) {
      this.deleteIconSync = false;
      this.unitListProfileSync = [];
    }
    return filteredUnits;
  }

  public onClickCheckbox(event: any) {
    if (event.target.checked === true) {
      this.unitListProfileSync.push(event.target.value);
      if (this.unitListProfileSync.length > 0) {
        this.deleteIconSync = true;
      }
    }
    if (event.target.checked === false) {
      const id = event.target.value;
      this.unitListProfileSync = this.unitListProfileSync.filter((item: any) => item !== id);
      if (this.unitListProfileSync.length === 1) {
        this.deleteIconSync = false;
      }
    }
  }

  public get approverStatus() {
    const userStatus = Service.approverUser();
    if (userStatus) {
      return true;
    }
    return false;
  }
}
